import InvitedSection from './InvitedSection';

export default InvitedSection;
